import TokenService from 'utils/axios/token.axios';
import { removeLocalStorage } from 'utils/func';

const defineRules = (can, cannot) => {
  const userLocal = localStorage.getItem('admin-user')
    ? JSON.parse(localStorage.getItem('admin-user'))
    : null;

  if (userLocal) {
    const { rules } = JSON.parse(atob(userLocal.accessToken.split('.')[1]));
    if (rules === undefined || rules?.length === 0) {
      // eslint-disable-next-line no-alert
      TokenService.removeUser();
      removeLocalStorage();
      window.location.href = `${process.env.PUBLIC_URL}/login`;
    } else {
      // eslint-disable-next-line array-callback-return
      rules.map((rule) => {
        const { subject, action, conditions, fields, inverted } = rule;

        if (inverted) cannot(action, subject, fields, conditions);
        else can(action, subject, fields, conditions);
      });
    }
  }
};

export default defineRules;
